(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('purchase-numbering-row', {
            parent: 'entity',
            url: '/purchase-numbering-row?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.purchaseNumberingRow.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/purchase-numbering-row/purchase-numbering-rows.html',
                    controller: 'PurchaseNumberingRowController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('purchaseNumberingRow');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('purchase-numbering-row-detail', {
            parent: 'entity',
            url: '/purchase-numbering-row/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.purchaseNumberingRow.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/purchase-numbering-row/purchase-numbering-row-detail.html',
                    controller: 'PurchaseNumberingRowDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('purchaseNumberingRow');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PurchaseNumberingRow', function($stateParams, PurchaseNumberingRow) {
                    return PurchaseNumberingRow.get({id : $stateParams.id});
                }]
            }
        })
        .state('purchase-numbering-row.new', {
            parent: 'purchase-numbering-row',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase-numbering-row/purchase-numbering-row-dialog.html',
                    controller: 'PurchaseNumberingRowDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                lastUsedNumber: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('purchase-numbering-row', null, { reload: true });
                }, function() {
                    $state.go('purchase-numbering-row');
                });
            }]
        })
        .state('purchase-numbering-row.edit', {
            parent: 'purchase-numbering-row',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase-numbering-row/purchase-numbering-row-dialog.html',
                    controller: 'PurchaseNumberingRowDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PurchaseNumberingRow', function(PurchaseNumberingRow) {
                            return PurchaseNumberingRow.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('purchase-numbering-row', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('purchase-numbering-row.delete', {
            parent: 'purchase-numbering-row',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase-numbering-row/purchase-numbering-row-delete-dialog.html',
                    controller: 'PurchaseNumberingRowDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PurchaseNumberingRow', function(PurchaseNumberingRow) {
                            return PurchaseNumberingRow.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('purchase-numbering-row', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
